import { Component } from '@angular/core';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { Utils } from '../../../../../common/js/Utils';

@Component({
  selector: 'advisor-links',
  moduleId: module.id,
  templateUrl: './advisor-links.component.html',
})
export class AdvisorLinksComponent {
  advisorName: string = '';
  advisorEmail: string = '';
  advisorPhone: string = '';

  ngOnInit(): void {
    const advisor = this.accountCenterService.primaryPolicy.primaryPolicyAgent.agent;
    this.advisorName = advisor.displayNameWithLastName;
    this.advisorEmail = advisor.person.email;
    this.advisorPhone = Utils.formatPhoneNumber(advisor.person.phone.number);
  }

  constructor(private accountCenterService: AccountCenterService) {}
}
